import React from "react";

import { Box } from "@mui/material";

interface UiActionLabelProps {
  children: React.ReactNode;
}

// Mimics the app's gradient button styling, but as a small non-interactive inline label for instructions
const UiActionLabel: React.FC<UiActionLabelProps> = ({ children }) => {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        background: "linear-gradient(0deg, #2270b5, #38bbcd)",
        color: "#FFFFFF",
        borderRadius: "999rem",
        px: 1,
        py: 0.2,
        mx: 0.25,
        fontSize: "0.85em",
        fontWeight: 600,
        lineHeight: 1.6,
        verticalAlign: "middle",
        whiteSpace: "nowrap",
        cursor: "default",
      }}
    >
      {children}
    </Box>
  );
};

export default UiActionLabel;
